import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { authHeader } from "@/utils/headers";
import { ENDPOINTS } from "@/api/application-api";
import { displayErrorToast, displayToast } from "@/utils/toast";
import { ToastType } from "@/enums/toast";

export const useDeleteInputVariableSet = (userToken: string) => {
  const queryClient = useQueryClient();
  const { workspaceId } = useParams();

  return useMutation<void, Error, number>({
    mutationFn: async (id: number) => {
      const response = await fetch(ENDPOINTS.input_variable_sets(Number(workspaceId), id), {
        method: "DELETE",
        headers: authHeader(userToken),
      });

      if (!response.ok) {
        throw new Error("Failed to delete input variable set");
      }
    },
    onSuccess: () => {
      displayToast("Input variable set deleted", ToastType.success);
      queryClient.invalidateQueries(["input-variable-sets", workspaceId]);
      queryClient.invalidateQueries({
        queryKey: ["folder-entities", workspaceId, null, undefined, undefined, true],
      });
    },
    onError: () => {
      displayErrorToast("Failed to delete input variable set");
    },
  });
};
